import { KhungHaiCot, NhomLoc } from "../components/LocHaiCot.jsx";
import { validWorkspace } from "../lib/validateWorkspace.js";
import CongCuIcon from "../components/CongCuIcon.jsx";
import { useState, useEffect } from "react";
import { track, trackOnce } from "../lib/track.js";
import { Link, useParams } from "react-router-dom";
import { TOOLS } from "../data/tools.js";
import {
  readWorkspace,
  writeWorkspace,
  clearWorkspace,
  downloadText,
  resetDraft,
  capNhatProfile,
  datDauXoa,
} from "../lib/workspace.js";
import { options } from "@shared/taxonomy.js";
import TaiKhoan from "../components/TaiKhoan.jsx";
import DanhSachMucTieu from "../components/DanhSachMucTieu.jsx";
import { TRANG_THAI, DOT, thongKe, GOI_Y_TOI_DA } from "@shared/danhSachMucTieu.js";
import DoiNgu from "../components/DoiNgu.jsx";
import NguonKhoiSo from "../components/NguonKhoiSo.jsx";
import BannerChuanBi, { HinhNguonVon } from "../components/BannerChuanBi.jsx";
import { docLogo } from "../lib/anhLogo.js";
import TienDoLoTrinh, { viecTiepTheoCuaToi, trangThaiViec } from "../components/TienDoLoTrinh.jsx";
import { cacTram, linkViec } from "../data/lo-trinh.js";
import { docGoiY, KHOA_NGANH } from "../lib/goiYTram.js";
import { useFunds } from "../lib/useFunds.js";
import { theoDoiDangNhap } from "../lib/auth.js";
import { dungPdfMotTrang } from "../lib/pdfMotTrang.js";
import {
  fileMotTrang,
  inMotTrang,
  chiaSeDuoc,
  chiaSeFile,
  dungHtmlMotTrang,
  tenFileAnToan,
} from "../lib/motTrang.js";

/** Sáu mục hồ sơ dùng để báo tiến độ. Đếm mục đã điền, KHÔNG quy ra phần trăm
 *  "sẵn sàng gọi vốn": điền đủ biểu mẫu không nói lên chất lượng doanh nghiệp. */
const MUC_HO_SO = [
  ["companyName", "Tên công ty"],
  ["moTa", "Một câu mô tả"],
  ["industry", "Ngành chính"],
  ["targetTy", "Mục tiêu gọi vốn"],
  ["dungVon", "Dùng vốn vào việc gì"],
  ["cotMoc", "Cột mốc 12–18 tháng"],
];



export default function Workspace() {
  const [data, setData] = useState({ drafts: {}, saved: [], tasks: {} }),
    [message, setMessage] = useState("");
  useEffect(() => {
    const refresh = () => setData(readWorkspace());
    refresh();
    const d = readWorkspace();
    const soNhap = Object.keys(d.drafts || {}).length;
    if (soNhap || (d.saved || []).length) {
      // Chỉ đếm số lượng, không gửi nội dung bản nháp.
      trackOnce("resume", "return_visit_resume", { value: Math.min(soNhap, 20) });
    }
    window.addEventListener("workspace-change", refresh);
    return () => window.removeEventListener("workspace-change", refresh);
  }, []);
  const drafts = Object.entries(data.drafts).filter(([id]) =>
    TOOLS.some((t) => t.toolId === id),
  );
  const profile = data.profile || {};
  // navigator không tồn tại lúc render sẵn HTML, nên chỉ hỏi sau khi đã chạy
  // trên trình duyệt — nếu không bản tĩnh và bản hydrate sẽ lệch nhau.
  const [coChiaSe, setCoChiaSe] = useState(false);
  const [cheDo, setCheDo] = useState("nha-dau-tu");
  const [dangTaoPdf, setDangTaoPdf] = useState(false);
  useEffect(() => {
    try {
      setCoChiaSe(chiaSeDuoc(new File(["x"], "x.html", { type: "text/html" })));
    } catch {
      setCoChiaSe(false);
    }
  }, []);
  const coGiDo =
    drafts.length > 0 ||
    data.saved.length > 0 ||
    (data.scenarios || []).length > 0 ||
    Object.values(profile).some((v) => v !== "" && v != null);
  const setProfile = (patch) => act(() => writeWorkspace(capNhatProfile(data, patch)));
  const daDien = MUC_HO_SO.filter(([k]) => String(profile[k] ?? "").trim() !== "");
  const conThieu = MUC_HO_SO.filter(([k]) => String(profile[k] ?? "").trim() === "");
  // Trạm gợi ý (từ Điểm sẵn sàng), ngành đã chọn ở Trạm 2 và tài khoản đăng
  // nhập chỉ đọc sau khi mount — trang được render sẵn lúc build.
  const [tramGoiY, setTramGoiY] = useState(null);
  const [nganh, setNganh] = useState("");
  const [nguoiDung, setNguoiDung] = useState(null);
  useEffect(() => {
    setTramGoiY(docGoiY()?.tram || null);
    try { setNganh(window.localStorage.getItem(KHOA_NGANH) || ""); } catch { /* bỏ qua */ }
    return theoDoiDangNhap(setNguoiDung);
  }, []);
  const viecTt = viecTiepTheoCuaToi(data, tramGoiY);
  const { funds } = useFunds();
  const slugQuy = (id) => funds.find((f) => f.fundId === id)?.slug;
  const ketQuaGanDay = [...drafts]
    .sort(([, a], [, b]) => new Date(b.updated) - new Date(a.updated))
    .slice(0, 3);
  const danhDau = (khoa, gt) =>
    act(() => writeWorkspace({ ...data, tasks: { ...data.tasks, [khoa]: gt } }));
  const [xemTruoc, setXemTruoc] = useState(false);  // Trang chia thành sáu mục, đi bằng thanh dọc bên trái. Mỗi mục là một
  // đường dẫn riêng (/ban-chuan-bi/<mục>) nên quay lại, làm mới hay gửi link
  // cho đồng đội đều mở đúng chỗ. Dữ liệu vẫn nằm chung một nơi như cũ.
  const { muc } = useParams();
  const MUC = [
    { slug: "tong-quan", ten: "Tổng quan", dem: "" },
    { slug: "ho-so", ten: "Thông tin startup", dem: `${daDien.length}/${MUC_HO_SO.length} mục` },
    { slug: "so-lieu", ten: "Kết quả & kịch bản", dem: drafts.length + (data.scenarios || []).length || "" },
    { slug: "ban-mot-trang", ten: "Hồ sơ gửi nhà đầu tư", dem: "" },
    { slug: "nguon-von", ten: "Quỹ mục tiêu", dem: data.saved.length || "" },
    { slug: "tai-khoan", ten: "Cài đặt & dữ liệu", dem: "" },
  ];
  const mucHienTai = MUC.some((m) => m.slug === muc) ? muc : "tong-quan";
  // Dải kêu gọi giữa các phần: chỉ hiện khi phần đó còn trống, và không lặp
  // lại đúng việc đã nêu ở khối "Việc tiếp theo" phía trên.
  const hienNguonVon = data.saved.length === 0;
  function act(fn) {
    try {
      fn();
      setMessage("Đã cập nhật trên thiết bị này.");
    } catch {
      setMessage(
        "Chưa thực hiện được. Kiểm tra bộ nhớ hoặc quyền tải file của trình duyệt.",
      );
    }
  }
  const tkQuy = thongKe(data.saved || []);
  const GHI_PHAN = {
    "tong-quan": <>Tiến độ {cacTram().length} trạm. Việc có bản lưu từ công cụ hiện “Có kết quả”; chỉ đánh dấu “Đã xong” khi kết quả đủ dùng cho hồ sơ. <Link to="/lo-trinh">Xem lộ trình →</Link></>,
    "ho-so": <>Đã điền {daDien.length}/{MUC_HO_SO.length} mục chính{conThieu.length > 0 ? `, còn thiếu: ${conThieu.map(([, ten]) => ten.toLowerCase()).join(", ")}` : ", đủ để xuất hồ sơ"}.</>,
    "so-lieu": <>Kết quả và kịch bản lưu từ các công cụ. Bản nháp luôn là lần lưu gần nhất của từng công cụ. <Link to="/cong-cu">Mở công cụ →</Link></>,
    "ban-mot-trang": <>Hồ sơ một trang tạo từ thông tin startup và kết quả đã lưu, xuất PDF ngay trên máy bạn.</>,
    "nguon-von": <><b>{tkQuy.dangTheo}</b>/{GOI_Y_TOI_DA} nơi đang theo đuổi. Đổi trạng thái từng quỹ để theo dõi bạn đã tiếp cận tới đâu.</>,
    "tai-khoan": <>Khi chưa đăng nhập, bản lưu chỉ nằm trên trình duyệt này: xoá dữ liệu trình duyệt hoặc đổi thiết bị có thể làm mất. File xuất ra có thể chứa số liệu nhạy cảm; bạn tự quyết định nơi lưu và người nhận.</>,
  };
  const ghiPhan = GHI_PHAN[mucHienTai];
  function exportSummary() {
    const lines = [
      "# Bản chuẩn bị gọi vốn (Fundraising.vn)",
      "Ngày xuất: " + new Date().toLocaleDateString("vi-VN"),
      "Kết quả tham khảo theo dữ liệu tại thời điểm lưu.",
      "",
      ...cacTram().flatMap((tram) => [
        `Trạm ${tram.so}: ${tram.ten}`,
        ...tram.viec.map((v, i) => {
          const tt = trangThaiViec(data, tram, v, i);
          return (tt === "xong" ? "[x] " : tt === "co-ket-qua" ? "[~] " : "[ ] ") + v.ten;
        }),
      ]),
      "",
      "## Danh sách quỹ mục tiêu",
      ...data.saved.map((s) => "- " + s.name + (s.trangThai ? ` (${TRANG_THAI[s.trangThai]}, ${DOT[s.dot || 2].nhan})` : "")),
      ...drafts.flatMap(([id, d]) => [
        "",
        "## " + TOOLS.find((t) => t.toolId === id).title,
        "Cập nhật: " + d.updated,
        d.summary || "Bản nháp chưa có kết quả tổng hợp.",
      ]),
      ...(data.scenarios || []).flatMap((s) => [
        "",
        "## Kịch bản: " + s.name,
        s.summary,
      ]),
    ];
    downloadText(
      "Ban-chuan-bi-goi-von.md",
      lines.join("\n"),
      "text/markdown;charset=utf-8",
    );
  }
  return (
    <>
      {/* Dải nhận diện cố ý mỏng: chỉ logo, tên và một dòng phụ.
          Bốn ô số liệu, khối "Việc tiếp theo" và tiến độ hồ sơ đã chuyển xuống
          trong mục Tổng quan. Lý do: người quay lại cần sổ dọc để đi tiếp, mà
          trước đây khối đầu trang cao tới mức đẩy sổ dọc khỏi màn hình đầu —
          bấm sang mục khác lại phải cuộn tìm. Đầu trang giờ chỉ trả lời "đây là
          bản chuẩn bị của ai", còn lại nằm trong mục. */}
      {/* Bỏ khối tên công ty ở đầu trang: Tổng quan đã có bảng hồ sơ và mục
          "Thông tin startup". Giữ một h1 ẩn cho trình đọc màn hình và SEO. */}
      {/* Đầu trang gọn cùng kiểu các mục khác (eyebrow, tiêu đề), thanh mục là
          hàng chip như /cong-cu, nằm ngay dưới tiêu đề nên luôn ở màn hình đầu.
          Khung xanh (bảng hồ sơ) nằm trong mục Tổng quan. */}
      <header className="ws-dau">
        <div>
          <p className="eyebrow">BẢN CHUẨN BỊ CỦA TÔI</p>
          <h1 id="ws-ten">Bản chuẩn bị gọi vốn</h1>
          {/* Ghi chú của từng phần đặt ở đây, để thẻ trắng hai cột bên dưới
              bắt đầu cùng một hàng. */}
          <p className="ws-dau-ghi">{ghiPhan}</p>
        </div>
      </header>
      <KhungHaiCot
        nhanLoc={`Phần: ${MUC.find((m) => m.slug === mucHienTai)?.ten}`}
        boLoc={
          <NhomLoc
            tieuDe="Bản chuẩn bị"
            tatCa=""
            chon={[mucHienTai]}
            gioiHan={10}
            ds={MUC.map((m) => ({ v: m.slug, nhan: m.ten, dem: m.dem || undefined, to: `/ban-chuan-bi/${m.slug}` }))}
          />
        }
      >
      <div className="ws-layout ws-mot-cot">
        <div className="ws-noi-dung">
          {mucHienTai === "tong-quan" && (<>
            <TienDoLoTrinh data={data} onDanhDau={danhDau} nganh={nganh} anDau />

            <div className="ws-the-luoi">
              <section className="cct ws-the" aria-labelledby="ws-gan-day" style={{ "--mau": "#86cfaa" }}>
                <span className="cct-dau">
                  <span className="cct-icon" aria-hidden="true"><CongCuIcon slug="tinh-runway" /></span>
                  <span className="cct-tram">{drafts.length} kết quả</span>
                </span>
                <h2 id="ws-gan-day" className="cct-ten">Kết quả gần đây</h2>
                {ketQuaGanDay.length ? (
                  <ul className="ws-gan-day">
                    {ketQuaGanDay.map(([id, d]) => {
                      const t = TOOLS.find((x) => x.toolId === id);
                      return (
                        <li key={id}>
                          <div>
                            <strong>{t.title}</strong>
                            <span className="nho muted">, lưu {new Date(d.updated).toLocaleString("vi-VN", { dateStyle: "short", timeStyle: "short" })}</span>
                          </div>
                          <Link to={"/cong-cu/" + t.slug}>Mở lại →</Link>
                        </li>
                      );
                    })}
                    {data.saved.length > 0 && (
                      <li>
                        <div><strong>{data.saved.length} nguồn vốn đã lưu</strong></div>
                        <Link to="/ban-chuan-bi/nguon-von">Xem danh sách →</Link>
                      </li>
                    )}
                  </ul>
                ) : (
                  <p className="cct-hoi">Chưa có kết quả nào. Trong mỗi công cụ, chọn “Lưu bản nháp” để kết quả xuất hiện ở đây.</p>
                )}
                <span className="cct-chan">
                  <span>Lưu từ các công cụ</span>
                  <Link className="cct-dung" to={drafts.length ? "/ban-chuan-bi/so-lieu" : "/cong-cu"}>{drafts.length ? `Tất cả kết quả (${drafts.length}) →` : "Mở công cụ →"}</Link>
                </span>
              </section>
              <section className="cct ws-the" aria-labelledby="ws-deck" style={{ "--mau": "#c3b1e6" }}>
                <span className="cct-dau">
                  <span className="cct-icon" aria-hidden="true"><CongCuIcon slug="pitch-deck-10-slide" /></span>
                  <span className="cct-tram">Miễn phí</span>
                </span>
                <h2 id="ws-deck" className="cct-ten">Nhận xét pitch deck</h2>
                <p className="cct-hoi">Gửi deck dạng PDF, nhận nhận xét từng slide kèm câu chữ gợi ý viết lại sau 15 đến 30 phút. Deck đã gửi và nhận xét đã nhận cũng nằm ở trang đó.</p>
                <span className="cct-chan">
                  <span>15 đến 30 phút</span>
                  <Link className="cct-dung" to="/nhan-xet-deck">Gửi deck hoặc xem nhận xét →</Link>
                </span>
              </section>
            </div>
          </>)}
          {mucHienTai === "ho-so" && (<>
            <section className="surface" id="ho-so-startup">
              <div className="section-bar"><h2>Thông tin startup</h2></div>
              <p className="muted">Chỉ nhập một lần ở đây. Các công cụ dùng lại làm điểm bắt đầu; tên và logo xuất hiện trên hồ sơ một trang và file Excel bạn xuất ra.</p>
              <div className="o-nhap profile-grid profile-grid-main">
                <div className="profile-company-field">
                  <label htmlFor="profile-company">Tên startup (tên hiển thị trên hồ sơ)</label>
                  <input
                    id="profile-company"
                    type="text"
                    maxLength={120}
                    placeholder="Công ty CP Acme"
                    value={profile.companyName || ""}
                    onChange={(e) => setProfile({ companyName: e.target.value })}
                  />
                </div>
                <div className="o-rong">
                  <label htmlFor="profile-mota">Công ty bạn làm gì? (một câu)</label>
                  <input
                    id="profile-mota"
                    type="text"
                    maxLength={200}
                    placeholder="Nền tảng quản lý kho cho nhà bán lẻ vừa và nhỏ"
                    value={profile.moTa || ""}
                    onChange={(e) => setProfile({ moTa: e.target.value })}
                  />
                </div>
                <div>
                  <label htmlFor="profile-website">Website</label>
                  <input
                    id="profile-website"
                    type="text"
                    maxLength={120}
                    placeholder="acme.vn"
                    value={profile.website || ""}
                    onChange={(e) => setProfile({ website: e.target.value })}
                  />
                </div>
                <div>
                  <label htmlFor="profile-email">Email liên hệ</label>
                  <input
                    id="profile-email"
                    type="email"
                    maxLength={120}
                    placeholder="founder@acme.vn"
                    value={profile.emailLienHe || ""}
                    onChange={(e) => setProfile({ emailLienHe: e.target.value })}
                  />
                </div>
                <div>
                  <label htmlFor="profile-nam">Năm thành lập</label>
                  <input
                    id="profile-nam"
                    type="number"
                    min="1990"
                    max="2100"
                    placeholder="2024"
                    value={profile.namThanhLap || ""}
                    onChange={(e) => setProfile({ namThanhLap: e.target.value })}
                  />
                </div>
                <div>
                  <label htmlFor="profile-nhansu">Quy mô đội ngũ (người)</label>
                  <input
                    id="profile-nhansu"
                    type="number"
                    min="1"
                    placeholder="8"
                    value={profile.soNhanSu || ""}
                    onChange={(e) => setProfile({ soNhanSu: e.target.value })}
                  />
                </div>
                <div className="profile-logo-field">
                  <label htmlFor="profile-logo">Logo (PNG, JPG, WEBP hoặc SVG)</label>
                  <input
                    id="profile-logo"
                    type="file"
                    accept="image/png,image/jpeg,image/webp,image/svg+xml"
                    onChange={async (e) => {
                      const file = e.target.files?.[0];
                      e.target.value = "";
                      if (!file) return;
                      try {
                        const logo = await docLogo(file);
                        setProfile({ logo });
                        setMessage("Đã lưu logo trên thiết bị này.");
                      } catch (err) {
                        setMessage("Chưa dùng được logo: " + err.message);
                      }
                    }}
                  />
                  {profile.logo && (
                    <div className="logo-xem">
                      <img src={profile.logo} alt="Logo đã chọn" height="40" />
                      <button
                        className="nut phu"
                        onClick={() => {
                          setProfile({ logo: "" });
                          setMessage("Đã bỏ logo.");
                        }}
                      >
                        Bỏ logo
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="o-nhap profile-grid profile-grid-details">
                <div><label htmlFor="profile-stage">Vòng dự kiến</label><select id="profile-stage" value={profile.roundType || ""} onChange={(e) => setProfile({ roundType: e.target.value })}><option value="">Chưa chọn</option>{options("STAGE").map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</select></div>
                <div><label htmlFor="profile-product">Giai đoạn sản phẩm</label><select id="profile-product" value={profile.productStage || ""} onChange={(e) => setProfile({ productStage: e.target.value })}><option value="">Chưa chọn</option>{options("PRODUCT_STAGE").map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</select></div>
                <div><label htmlFor="profile-city">Trụ sở</label><select id="profile-city" value={profile.city || ""} onChange={(e) => setProfile({ city: e.target.value })}><option value="">Chưa chọn</option><option value="HCM">TP. Hồ Chí Minh</option><option value="HN">Hà Nội</option><option value="DN">Đà Nẵng</option><option value="HP">Hải Phòng</option><option value="CT">Cần Thơ</option><option value="BD">Bình Dương</option><option value="DNAI">Đồng Nai</option><option value="KHAC">Tỉnh/thành khác</option></select></div>
                <div><label htmlFor="profile-target">Mục tiêu gọi vốn (tỷ đồng)</label><input id="profile-target" type="number" min="0" step="0.5" placeholder="chưa rõ" value={profile.targetTy || ""} onChange={(e) => setProfile({ targetTy: e.target.value })} /></div>
                <div className="o-rong">
                  <label htmlFor="profile-dungvon">Dùng vốn vào việc gì?</label>
                  <textarea
                    id="profile-dungvon"
                    rows={2}
                    maxLength={400}
                    placeholder="60% tuyển 3 kỹ sư và 1 nhân sự bán hàng, 25% chi phí vận hành, 15% marketing thử nghiệm"
                    value={profile.dungVon || ""}
                    onChange={(e) => setProfile({ dungVon: e.target.value })}
                  />
                </div>
                <div className="o-rong">
                  <label htmlFor="profile-cotmoc">Cột mốc cần đạt trong 12–18 tháng</label>
                  <input
                    id="profile-cotmoc"
                    type="text"
                    maxLength={250}
                    placeholder="Đi từ 20 lên 100 khách trả tiền, doanh thu định kỳ 400 triệu/tháng"
                    value={profile.cotMoc || ""}
                    onChange={(e) => setProfile({ cotMoc: e.target.value })}
                  />
                </div>
                <div><label htmlFor="profile-industry">Ngành chính</label><select id="profile-industry" value={profile.industry || ""} onChange={(e) => setProfile({ industry: e.target.value })}><option value="">Chưa chọn</option>{options("INDUSTRY").map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</select></div>
                <div><label htmlFor="profile-customer">Khách hàng chính</label><select id="profile-customer" value={profile.customerType || ""} onChange={(e) => setProfile({ customerType: e.target.value })}><option value="">Chưa chọn</option>{options("CUSTOMER_TYPE").map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</select></div>
              </div>
              <div className="hang-nut"><Link className="nut" to="/cong-cu/quy-phu-hop">Dùng hồ sơ để tìm nguồn vốn →</Link><Link className="nut phu" to="/cong-cu/diem-san-sang-goi-von">Rà mức sẵn sàng →</Link></div>
            </section>
            <DoiNgu
              danhSach={profile.doiNgu}
              onChange={(doiNgu) => setProfile({ doiNgu })}
            />
          </>)}
          {mucHienTai === "so-lieu" && (<>
            <section aria-label={`Kết quả đã lưu (${drafts.length})`}>
              {drafts.length ? (
                <ul className="ws-kq ws-kq-dau">
                  {[...drafts].sort(([, a], [, b]) => new Date(b.updated) - new Date(a.updated)).map(([id, d]) => {
                    const t = TOOLS.find((x) => x.toolId === id);
                    return (
                      <li key={id}>
                        <span className="ws-kq-icon" aria-hidden="true"><CongCuIcon slug={t.slug} /></span>
                        <div className="ws-kq-than">
                          <strong>{t.title}</strong>
                          <span className="ws-kq-ngay">Lưu {new Date(d.updated).toLocaleString("vi-VN", { dateStyle: "short", timeStyle: "short" })}</span>
                          <details>
                            <summary>Xem kết quả lúc lưu</summary>
                            <p className="snapshot">{d.summary || "Chưa có kết quả tổng hợp. Mở bản nháp để tiếp tục."}</p>
                          </details>
                        </div>
                        <div className="ws-kq-nut">
                          <Link className="ws-kq-mo" to={"/cong-cu/" + t.slug}>Mở lại →</Link>
                          <button type="button" className="text-button danger"
                            onClick={() => { if (confirm("Xoá bản nháp " + t.title + " trên thiết bị này?")) act(() => resetDraft(id)); }}>
                            Xoá
                          </button>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <p>Chưa có kết quả nào. <Link to="/cong-cu/tinh-runway">Bắt đầu bằng tính runway →</Link></p>
              )}
            </section>
            <section className="section-space">
              <h2>Kịch bản đã lưu ({(data.scenarios || []).length})</h2>
              <p className="muted nho">
                Kịch bản là một phương án bạn lưu lại để so sánh (tối đa 20). Chỉ so
                sánh các kịch bản của cùng một công cụ.
              </p>
              <div className="ws-kb">
                {(data.scenarios || []).map((s) => (
                  <article className="surface" key={s.id}>
                    <span className="pill">
                      {TOOLS.find((t) => t.toolId === s.tool)?.title}
                    </span>
                    <h3>{s.name}</h3>
                    <p className="meta">
                      {new Date(s.updated).toLocaleString("vi-VN")}
                    </p>
                    <p className="snapshot">
                      {s.summary || "Chưa có kết quả tổng hợp."}
                    </p>
                    <div className="hang-nut">
                      <button
                        className="nut phu"
                        onClick={() => {
                          if (
                            confirm(
                              "Mở kịch bản này sẽ thay bản nháp đang lưu của công cụ tương ứng. Tiếp tục?",
                            )
                          )
                            act(() => {
                              const d = readWorkspace();
                              d.drafts[s.tool] = {
                                values: s.values,
                                summary: s.summary,
                                updated: s.updated,
                              };
                              writeWorkspace(d);
                              window.location.assign(
                                "/cong-cu/" +
                                  TOOLS.find((t) => t.toolId === s.tool).slug,
                              );
                            });
                        }}
                      >
                        Mở kịch bản
                      </button>
                      <button
                        className="nut phu"
                        onClick={() =>
                          act(() =>
                            writeWorkspace({
                              ...data,
                              ...datDauXoa(data, `scenario:${s.id}`),
                              scenarios: data.scenarios.filter((x) => x.id !== s.id),
                            }),
                          )
                        }
                      >
                        Bỏ kịch bản
                      </button>
                    </div>
                  </article>
                ))}
              </div>
              {!data.scenarios?.length && (
                <p>Chọn “Lưu kịch bản” trong công cụ sau khi thử một phương án.</p>
              )}
            </section>
          </>)}
          {mucHienTai === "ban-mot-trang" && (<>
            <div className="surface">
              <div className="section-bar">
                <h2>Hồ sơ một trang</h2>
                <span className="pill">Doanh nghiệp tự khai</span>
              </div>
              {conThieu.length > 0 ? (
                <div className="ws-thieu-hs">
                  <p><strong>Còn thiếu {conThieu.length} thông tin</strong>. Hồ sơ vẫn xuất được, nhưng các mục này sẽ trống:</p>
                  <ul>
                    {conThieu.map(([k, ten]) => (
                      <li key={k}>
                        {ten}:{" "}
                        <Link to={k === "targetTy" ? "/cong-cu/goi-bao-nhieu" : "/ban-chuan-bi/ho-so"}>
                          {k === "targetTy" ? "tính số vốn cần gọi" : "điền"} →
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <p className="trang-thai-xong">Đã đủ {MUC_HO_SO.length} thông tin chính.</p>
              )}
              <fieldset className="chon-che-do">
                <legend>Gửi cho ai?</legend>
                <label className="task-row">
                  <input
                    type="radio"
                    name="che-do-mot-trang"
                    checked={cheDo === "nha-dau-tu"}
                    onChange={() => setCheDo("nha-dau-tu")}
                  />
                  <span>
                    <strong>Bản gửi nhà đầu tư:</strong> mô tả, đội ngũ, số vốn đang gọi,
                    sử dụng vốn, số liệu và cách liên hệ. Bỏ điểm tự chấm, danh sách
                    quỹ bạn đang theo dõi và checklist nội bộ.
                  </span>
                </label>
                <label className="task-row">
                  <input
                    type="radio"
                    name="che-do-mot-trang"
                    checked={cheDo === "noi-bo"}
                    onChange={() => setCheDo("noi-bo")}
                  />
                  <span>
                    <strong>Bản nội bộ:</strong> có thêm điểm sẵn sàng, quỹ đang theo
                    dõi và việc cần làm. Đọc với đồng sáng lập, đừng gửi ra ngoài.
                  </span>
                </label>
              </fieldset>
              <NguonKhoiSo data={data} setProfile={setProfile} />
              <div className="hang-nut">
                <button
                  className="nut"
                  disabled={!coGiDo || dangTaoPdf}
                  onClick={async () => {
                    setDangTaoPdf(true);
                    setMessage("Đang tạo PDF…");
                    try {
                      const d = readWorkspace();
                      const byte = await dungPdfMotTrang(d, cheDo);
                      track("tool_export", { tool: "mot-trang", kind: "pdf" });
                      const ten = tenFileAnToan(
                        d.profile?.companyName ? `Ho-so-${d.profile.companyName}` : "Ban-mot-trang",
                        "pdf",
                      );
                      const file = new File([byte], ten, { type: "application/pdf" });
                      // Điện thoại: đưa thẳng vào trình chia sẻ để gửi Zalo/Messenger.
                      // Máy tính: tải về như bình thường.
                      if (chiaSeDuoc(file)) {
                        await chiaSeFile(
                          file,
                          d.profile?.companyName
                            ? `${d.profile.companyName}: hồ sơ một trang`
                            : "Hồ sơ một trang",
                        );
                        setMessage("Đã tạo PDF.");
                      } else {
                        downloadText(ten, byte, "application/pdf");
                        setMessage("Đã tải PDF về máy.");
                      }
                    } catch (err) {
                      // Tạo PDF hỏng thì vẫn còn đường in ra PDF từ trình duyệt,
                      // đừng để người dùng cụt đường.
                      setMessage(
                        "Chưa tạo được PDF: " + err.message + " Bạn có thể dùng nút xem và in.",
                      );
                    } finally {
                      setDangTaoPdf(false);
                    }
                  }}
                >
                  {dangTaoPdf ? "Đang tạo PDF…" : "Tải PDF"}
                </button>
                <button
                  className="nut phu"
                  disabled={!coGiDo}
                  onClick={() => setXemTruoc((x) => !x)}
                  aria-expanded={xemTruoc}
                >
                  {xemTruoc ? "Ẩn bản xem trước" : "Xem trước"}
                </button>
                <button
                  className="nut phu"
                  disabled={!coGiDo}
                  onClick={() => act(() => inMotTrang(readWorkspace(), cheDo))}
                >
                  In
                </button>
              </div>
              {!coGiDo && (
                <p className="nho muted">Chưa xuất được vì bản chuẩn bị còn trống. Điền thông tin startup hoặc lưu kết quả một công cụ trước.</p>
              )}
              {xemTruoc && coGiDo && (
                <iframe
                  className="ws-xem-truoc"
                  title="Xem trước hồ sơ một trang"
                  srcDoc={dungHtmlMotTrang(data, cheDo)}
                  sandbox=""
                />
              )}
              <p className="nho muted">
                PDF được tạo ngay trên máy bạn và không được đăng lên đâu cả. Bạn tự
                chọn gửi cho ai. Trên điện thoại, nút Tải PDF mở thẳng trình chia sẻ
                để gửi qua Zalo hoặc Messenger.
              </p>
            </div>
          </>)}
          {mucHienTai === "nguon-von" && (<>
            {hienNguonVon && (
              <BannerChuanBi
                id="nguon-von"
                eyebrow="BƯỚC TIẾP THEO"
                tieuDe="Chưa có quỹ mục tiêu nào. Tìm những nơi hợp với giai đoạn của bạn"
                moTa="Công cụ lọc theo ngành, giai đoạn và số vốn trong hồ sơ. Chọn khoảng 15 đến 20 nơi hợp nhất, chúng sẽ nằm ở đây để chia đợt và theo dõi tiếp cận."
                chinh={{ nhan: "Tìm nguồn vốn phù hợp", to: "/cong-cu/quy-phu-hop" }}
                phu={{ nhan: "Xem toàn bộ danh mục", to: "/nguon-von" }}
                hinh={<HinhNguonVon />}
              />
            )}
            {!hienNguonVon && (
              <DanhSachMucTieu data={data} funds={funds} tenCongTy={data.profile?.companyName} anDau />
            )}
          </>)}
          {mucHienTai === "tai-khoan" && (<>
            <TaiKhoan />
            {/* Hai file này KHÔNG phải thứ gửi cho quỹ — .md là ghi chú thô, .json là
                bản sao kỹ thuật. Để chung hàng với nút xuất hồ sơ thì người dùng dễ
                gửi nhầm, nên thu vào khối sao lưu và gọi đúng tên. */}
            <details className="surface section-space">
              <summary>Sao lưu và khôi phục</summary>
              <p className="muted nho">
                Dùng để giữ bản sao cho chính bạn hoặc chuyển sang máy khác. Đây không
                phải file để gửi cho nhà đầu tư. File đó là hồ sơ một trang ở mục Hồ sơ gửi nhà đầu tư.
              </p>
              <div className="hang-nut">
                <button
                  className="nut phu"
                  disabled={
                    !drafts.length && !data.saved.length && !data.scenarios?.length
                  }
                  onClick={() => act(exportSummary)}
                >
                  Ghi chú dạng văn bản (.md)
                </button>
                <button
                  className="nut phu"
                  onClick={() =>
                    act(() =>
                      downloadText(
                        "Fundraising-backup.json",
                        JSON.stringify({ version: 1, ...data }, null, 2),
                        "application/json",
                      ),
                    )
                  }
                >
                  Bản sao đầy đủ (.json)
                </button>
              </div>
            </details>
            <details className="surface">
              <summary>Quản lý dữ liệu thiết bị</summary>
              <p>
                Xuất bản sao trước khi xóa. Bản tóm tắt dùng để đọc; bản JSON giữ dữ
                liệu đầu vào để khôi phục.
              </p>
              <label htmlFor="backup-import">
                Khôi phục bản sao JSON (thay dữ liệu đang lưu)
              </label>
              <input
                type="file"
                accept=".json,application/json"
                id="backup-import"
                onChange={async (e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;
                  try {
                    if (file.size > 2000000) throw Error("File vượt 2 MB.");
                    const x = JSON.parse(await file.text());
                    if (!validWorkspace(x))
                      throw Error("Bản sao không đúng định dạng hoặc phiên bản.");
                    if (
                      confirm(
                        "Thay toàn bộ dữ liệu đang lưu bằng bản sao này? Hãy xuất bản sao hiện tại trước nếu cần.",
                      )
                    ) {
                      writeWorkspace(x);
                      window.location.reload();
                    }
                  } catch (err) {
                    setMessage("Không khôi phục được: " + err.message);
                  }
                  e.target.value = "";
                }}
              />
              <button
                className="nut phu danger"
                onClick={() => {
                  if (
                    confirm(
                      "Xóa toàn bộ bản nháp, checklist và nguồn vốn đã lưu trên thiết bị? Hành động này không thể hoàn tác nếu chưa có bản sao.",
                    )
                  )
                    act(clearWorkspace);
                }}
              >
                Xóa toàn bộ dữ liệu trên thiết bị
              </button>
            </details>
          </>)}
        </div>
      </div>
      </KhungHaiCot>
      <p role="status">{message}</p>
      {/* Tên công ty để ở cuối trang, chữ nhỏ (đầu trang chỉ cần tên mục). */}
      <p className="ws-chan">
        {profile.companyName
          ? <>Bản chuẩn bị của <b>{profile.companyName}</b>. <Link to="/ban-chuan-bi/ho-so">Sửa thông tin startup</Link></>
          : <>Chưa có tên startup. <Link to="/ban-chuan-bi/ho-so">Điền thông tin startup</Link></>}
        {nguoiDung ? <>. Đồng bộ với {nguoiDung.email}.</> : <>. <Link to="/ban-chuan-bi/tai-khoan">Đăng nhập để đồng bộ</Link></>}
      </p>
    </>
  );
}
